import { render, staticRenderFns } from "./notify_transfer.vue?vue&type=template&id=11db0a8c"
import script from "./notify_transfer.vue?vue&type=script&lang=js"
export * from "./notify_transfer.vue?vue&type=script&lang=js"
import style0 from "./notify_transfer.vue?vue&type=style&index=0&id=11db0a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports